import { Injectable, inject } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { JobBoard, JobBoardPayloadParams } from '@recruitee/job-boards-types';

import { OfferJobBoardActions, OfferJobBoardSelectors } from './offer-job-board.store';

@Injectable({ providedIn: 'root' })
export class OfferJobBoardStoreService {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  public getOfferJobBoards(offerId: number): Observable<JobBoard[]> {
    return this.store
      .select(OfferJobBoardSelectors.entities({ scope: offerId.toString() }))
      .pipe(filterBoolean);
  }

  public getOfferJobBoardCounters(offerId: number): Observable<{ all: number; published: number }> {
    return this.store
      .select(OfferJobBoardSelectors.counters({ scope: offerId.toString() }))
      .pipe(filterBoolean);
  }

  public getOfferJobBoardPublishedCounters(offerId: number): Observable<number> {
    return this.actions$.pipe(
      ofType(OfferJobBoardActions.fetchCountersSuccess),
      filter(action => action.payload.id === offerId),
      map(action => action.payload.counters.published),
    );
  }

  public getOfferJobBoardsLoaded(offerId: number): Observable<boolean> {
    return this.store.select(OfferJobBoardSelectors.isLoaded({ scope: offerId.toString() }));
  }

  public fetchOfferJobBoards(offerId: number): void {
    this.store.dispatch(
      OfferJobBoardActions.fetchCollection({ payload: { scope: offerId.toString() } }),
    );
  }

  public fetchPaginatedOfferJobBoards(offerId: number, params?: JobBoardPayloadParams): void {
    this.store.dispatch(
      OfferJobBoardActions.fetchPaginated({
        payload: {
          scope: offerId.toString(),
          params,
        },
      }),
    );
  }

  public fetchOfferJobBoardsCounters(offerId: number): void {
    this.store.dispatch(OfferJobBoardActions.fetchCounters({ payload: { id: offerId } }));
  }
}
